import { InsuranceTypeEnum } from '../../enums/insurance/insurance-type.enum'
import { EnrollmentInsurance } from '../enrollment-insurance/enrollment-ensurance'
import { InsuranceEnrollmentPropositionInput } from '../enrollment-proposition/enrollment-proposition-input'
import { EnrollmentInsuranceLike, PartialInsuranceInput } from './insurance'

export class InsuranceProperties {
  static hasNestedInsurance = (
    insurance: EnrollmentInsuranceLike
  ): insurance is Partial<Pick<EnrollmentInsurance, 'id' | 'price'>> & {
    insurance?: PartialInsuranceInput | null
  } => !!insurance && typeof insurance === 'object' && 'insurance' in insurance

  static getEnrollmentInsuranceDetails = (
    insurance: EnrollmentInsuranceLike
  ): PartialInsuranceInput | undefined => {
    if (!insurance) return undefined

    if (!this.hasNestedInsurance(insurance)) return insurance

    if (!insurance.insurance) return undefined

    return {
      ...insurance.insurance,
      price: insurance.price ?? insurance.insurance.price
    }
  }

  static getEnrollmentInsuranceName = (insurance: EnrollmentInsuranceLike): string | undefined =>
    this.getEnrollmentInsuranceDetails(insurance)?.name

  static getEnrollmentInsurancePrice = (insurance: EnrollmentInsuranceLike): number | undefined =>
    this.getEnrollmentInsuranceDetails(insurance)?.price

  static getEnrollmentInsuranceType = (
    insurance: EnrollmentInsuranceLike
  ): InsuranceTypeEnum | undefined => this.getEnrollmentInsuranceDetails(insurance)?.type

  static hasEnrollmentInsuranceType = (
    insurances: EnrollmentInsuranceLike[] | undefined,
    type: InsuranceTypeEnum
  ): boolean =>
    !!insurances?.some((insurance) => this.getEnrollmentInsuranceType(insurance) === type)

  static mapEnrollmentInsurancesToInput = (
    insurances: EnrollmentInsuranceLike[] | undefined
  ): InsuranceEnrollmentPropositionInput[] =>
    insurances?.flatMap((insurance) => {
      const details = this.getEnrollmentInsuranceDetails(insurance)

      return !!details?.id && !!details.name && !!details.type
        ? [{ id: details.id, name: details.name, type: details.type, price: details.price }]
        : []
    }) ?? []

  // a different set of insurance ids, whatever order the modal sends them in
  static haveInsurancesChanged = (
    insurances: EnrollmentInsuranceLike[] | undefined,
    insuranceIds: number[]
  ): boolean => {
    const savedIds = new Set(this.mapEnrollmentInsurancesToInput(insurances).map(({ id }) => id))
    return savedIds.size !== insuranceIds.length || insuranceIds.some((id) => !savedIds.has(id))
  }
}
